export const localeUrlRegex = markRaw(new RegExp('^/[a-z]{2}/|^/[a-z]{2}$'));

export const informationalUrls = [
  "/no-script-error",
  "/old-browser-error",
  "/internal-server-error",
  "/404",
];

export const robotsBlacklistRegex = /datenschutz|cookie-richtlinie|agb|impressum/;